var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#FAFAFA"}},[_c('router-view'),_c('loadingcomponent',{attrs:{"is_loading":_vm.$store.getters.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }